import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { usePickerContext, usePickerTranslations } from '@mui/x-date-pickers/hooks';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { getRpmRunSubject } from '../../../store/RpmRun';

export const CustomActionBar = (props: PickersActionBarProps) => {
  const { actions, className } = props;
  const translations = usePickerTranslations();
  const { cancelValueChanges, acceptValueChanges, setValue } = usePickerContext();
  const [runDate, setRunDate] = useState<Date | null>(null);

  useEffect(() => {
    const rpmRunSub = getRpmRunSubject().subscribe((run) => {
      if (run && run.runLastDayOfMonth) {
        setRunDate(new Date(run.runLastDayOfMonth));
      }
    });

    return () => {
      if (rpmRunSub) rpmRunSub.unsubscribe();
    };
  }, []);

  const handleLatestRunClick = () => {
    if (runDate) {
      setValue(runDate);
      acceptValueChanges();
    }
  };

  if (actions == null || actions.length === 0) {
    return null;
  }

  const actionButtons = actions.map((actionType) => {
    switch (actionType) {
      case 'cancel':
        return (
          <Button
            onClick={cancelValueChanges}
            key={actionType}>
            {translations.cancelButtonLabel}
          </Button>
        );
      case 'accept':
        return (
          <Button
            onClick={acceptValueChanges}
            key={actionType}>
            {translations.okButtonLabel}
          </Button>
        );
      case 'next':
        return (
          <Button
            onClick={handleLatestRunClick}
            key={actionType}
            disabled={!runDate}>
            Latest Run
          </Button>
        );
      default:
        return null;
    }
  });

  return <DialogActions className={className}>{actionButtons}</DialogActions>;
};
